<template>
  <div>
    <el-select
      v-if="this.show_companies && !usuarioEmpresa"
      filterable
      v-model="selected_empresa.id"
      @change="cambioEmpresa"
      clearable
      placeholder="Seleccionar empresa"
      no-data-text="No hay datos que coincidan"
      no-match-text="No hay datos que coincidan"
    >
      <el-option
        v-for="(empresa, idx) in empresas"
        :key="idx"
        :label="empresa.nombre_empresa"
        :value="empresa.id"
      >
      </el-option>
    </el-select>
    <div class="row mt-3" v-if="selected_empresa.id">
      <div class="col-12 text-center text-muted" v-if="cargando">
        <i class="fa fa-spin fa-spinner"> </i> Cargando ubicaciones
      </div>
      <div
        class="col-12 text-center text-muted"
        v-else-if="selected_empresa.id && !ubicaciones.length"
      >
        <i class="fa fa-exclamation-triangle"></i> La empresa no tiene ubicaciones
        registradas
      </div>
      <div class="col-md-12 col-sm-12 col-lg-12" v-else-if="ubicaciones.length">
        <b-input-group class="mb-2">
          <b-form-input v-model="filterText" placeholder="Filtrar ubicaciones" />
          <b-input-group-append>
            <b-button
              v-show="ubicaciones.length > 0 && !usuarioTecnico"
              variant="primary"
              @click="guardarMasivo"
            >
              Asignar ubicaciones marcadas
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <!-- Ubicaciones -->
      <div class="col-12" style="max-height: 400px; overflow: auto">
        <el-tree
          @check-change="handleCheckChange"
          :data="ubicaciones"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
          :default-checked-keys="selecionadosIds"
          :filter-node-method="filterNode"
        >
          <span class="d-inline-flex align-items-center" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>

            <span
              v-if="data.company_country && data.company_country.country"
              class="ml-2 d-inline-flex align-items-center"
            >
              <img
                :src="`https://flagsapi.com/${data.company_country.country.code.toUpperCase()}/flat/64.png`"
                style="width: 18px; height: 18px;"
                @error="$event.target.style.display='none'"
                @load="$event.target.style.display=''"
              >
            </span>

            <span
              v-else-if="data.parent_location && data.parent_location.company_country && data.parent_location.company_country.country"
              class="ml-2 d-inline-flex align-items-center"
            >
              <img
                :src="`https://flagsapi.com/${data.parent_location.company_country.country.code.toUpperCase()}/flat/64.png`"
                style="width: 18px; height: 18px;"
                @error="$event.target.style.display='none'"
                @load="$event.target.style.display=''"
              >
            </span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "ubicaciones",
  props: {
    IdProducto: {
      type: Number,
      default: null,
      required: true
    },
    show_companies: {
        default: true,
        required: false
    }
  },
  data: function () {
    return {
      empresa_id: null,
      cargando: false,
      selecionadosIds: [],
      selecUbicaciones: [],
      initialSelection: [],
      empresaSeleccionada: null,
      filterText: "",
      defaultProps: {
        disabled: "disabled",
      },
    };
  },
  computed: {
    ...mapState("asignacionproductos", [
      "empresas",
      "selected_empresa",
      "ubicaciones",
      "selectedUbicacion",
      "seleccionado",
      "errorUbicacion",
      "info",
      "filtroUbicacion",
      "ubicacionesCantidad",
    ]),
    ...mapState("productos", ["esAdminTec"]),
    ...mapState("autenticacion", ["usuarioTecnico", "usuarioEmpresa"]),
    ...mapGetters("asignacionproductos", ["getSeleccionado"]),
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {

    if (this.selected_empresa.id) {
        this.loadCompany();
        this.cambioEmpresa(this.selected_empresa.id);
    }
  },
  methods: {
    /**
     * @description: Metodo para obtener las ubicaciones de un producto
     * @param {Object} data
     * @return: void
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },

    /**
     * @description: Metodo de cambio de estado de un check
     * @param {Object} data
     * @return: void
     */
    handleCheckChange(data, checked) {
      if (!checked) {
        this.initialSelection = this.initialSelection;
      }
      if (this.selecionadosIds.includes(data.id) && !checked) {
        this.selecionadosIds.forEach(function (item, index, object) {
          if (item === data.id) {
            object.splice(index, 1);
          }
        });
      }

      if (checked && !this.selecionadosIds.includes(data.id)) {
        this.selecionadosIds.push(data.id);
      }
    },

    /**
     * @description: Metodo para setear las ubicaiones cuando se cambia de empresa.
     * @param {int} empresa_id
     * @return: void
     */
    cambioEmpresa(empresa_id) {
      let empresa = this.empresas.find((e) => e.id === empresa_id);
      if (empresa) {
        this.toggleVisibleEmp(empresa, this.IdProducto);
      }
    },

    loadCompany(){
        this.toggleVisibleEmp(this.selected_empresa,this.IdProducto)
    },

    /**
     * @description: Metodo para setear las ubicaiones cuando se cambia de empresa.
     */
    async toggleVisibleEmp(empresa, producto) {
      let data = {};
      this.empresa_id = empresa.id; //asignacion empresa id para guardar
      this.cargando = true;

      data.empresa = empresa.id;
      data.producto = parseInt(producto);
      data.asigEmpresa = false;

      this.setInfo(data);
      this.selecionadosIds = [];
      await this.getUbicacionProd(this.info);
      this.setSeleccionados();
      await this.setChecked(this.ubicaciones);
      this.cargando = false;
      await this.getCamposPersonalizados({
        id_empresa: empresa.id,
        id_producto: this.IdProducto,
      });
      await this.listarUbicacionesCantidad({
        company_id: empresa.id,
        product_id: this.IdProducto,
      });
      this.addItemsUbicacionesCantidad();
      this.selecionadosIds = [];
      this.pusherSeleccionados(this.ubicaciones);
    },

    /**
     * @description: Metodo para llenar el array de ids de ubicaciones seleccionadas.
     * @param {Object} data
     * @return: void
     */
    pusherSeleccionados(data) {
      let ubicaciones = data;
      ubicaciones.forEach((element) => {
        if (element.hasOwnProperty("get_product")) {
          if (element.get_product.length > 0) {
            element.get_product.forEach((el) => {
              if (el.id_producto == this.IdProducto ) this.selecionadosIds.push(element.id);
            });
          }
        }
        if (element.children.length) this.pusherSeleccionados(element.children);
      });
      this.initialSelection = [...new Set(this.selecionadosIds)];
    },

    /**
     * @description: Metodo para setear las ubicaiones seleccionadas.
     * @return: void
     */
    async setChecked(ubicacion) {
      await ubicacion.map(async (i) => {
        if (i.checked) {
          this.seleccionados(i.id);
        }
        await this.setChecked(i.children);
      });
    },

    /**
     * @description: Metodo para guardar las ubicaciones seleccionadas.
     * @return: void
     */
    async guardarMasivo() {
        this.initialSelection = this.initialSelection.filter((item) => {
          return !this.selecionadosIds.includes(item);
        });

        if (this.initialSelection.length > 0) {
          const payload = {
            company_id: this.empresa_id,
            product_id: this.IdProducto,
            locations: this.initialSelection,
          };
          await this.inactivateProducts(payload);
        }

      // Las siguientes funciones se ejecutarán después de que se haya completado la primera parte
      await this.setMasivo(this.selecionadosIds);
      await this.guardaUbicacion({
        producto_id: this.IdProducto,
        empresa_id: this.empresa_id,
      });
      await this.getUbicacionProd(this.info);
      this.setSeleccionados();
      await this.setChecked(this.ubicaciones);
      await this.getUbicacionProd(this.info);
      this.$refs.tree.filter(this.filterText);
      this.initialSelection = [...new Set(this.selecionadosIds)];
    },

    /**
     * @description: Metodo para agregar las cantidades de las ubicaciones.
     * @return: void
     */
    addItemsUbicacionesCantidad() {
      this.ubicacionesCantidad.forEach((ele) => {
        if (!ele.get_product_ubicacion.get_product_ubicacion_quantity) {
          ele.get_product_ubicacion.get_product_ubicacion_quantity = {
            capacity: null,
            quantity: null,
            sys_list_unit_id: null,
          };
        }
      });
    },

    ...mapActions("asignacionproductos", [
      "getInfoAsignacion",
      "getUbicacionProd",
      "asignarBaseAreaProd",
      "asignarUbicacionProd",
      "getUbicacionProd",
      "getCamposPersonalizados",
      "guardaUbicacion",
      "listarUbicacionesCantidad",
    ]),
    ...mapMutations("asignacionproductos", [
      "limpiarBasesAreasProd",
      "seleccionados",
      "setInfo",
      "setSeleccionados",
      "setUbicacionProducto",
      "setUbicacionEmpresa",
      "seleccionados",
      "setMasivo",
      "setQuitaMasivo",
    ]),
    ...mapActions("accidents_high", ["inactivateProducts"]),
  },
};
</script>

<style scoped>
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #097b83;
  border-color: #dcdfe6;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #ffffff;
  width: 5px;
  margin-top: 2px;
  margin-left: 1px;
}
.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #fff;
  margin-top: 10px;
}
.el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: #ffffff;
  margin-top: 1px;
  margin-left: 2px;
}
</style>
